import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { QuickSearchResponse } from '@core/search-types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<QuickSearchResponse>()(
  'SearchQuick',
  {
    customActions: adapter => ({
      fetch: (
        state,
        payload: {
          query: string;
          options: { only?: 'candidates'; limit?: number; isHired?: boolean };
        },
      ) => adapter.markAsPending(state),
    }),
  },
);

const { fetch, fetchSuccess, fetchFailed } = actions;
const SearchQuickActions = { fetch, fetchSuccess, fetchFailed };

export {
  SearchQuickActions,
  selectors as SearchQuickSelectors,
  reducer as SearchQuickReducer,
  namespace as SearchQuickNamespace,
};
